<template>
<div class="item" :class="itemType">
  <div class="item__img">
    <i class="icon-setting"></i>
  </div>
  <div class="item__main">
    <div class="item__head">{{content}}</div>
    <div class="item__body">{{type}}</div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    content: String,
    type: String
  },
  computed: {
    itemType(){
      if(this.type == 'Type1')
        return 'theme-cyan'
      else if(this.type == 'Type2')
        return 'theme-purple'
      else
        return 'theme-green'
    }
  }
}
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #C63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: '../assets/img/';

//2-VENDORS

//3-TOOLS
//functions
//background-image function
@function bimg($img){
  @return url($p-img+$img);
}
//mixins
@mixin mqwh($min-width,$max-height){
  @media (min-width: $min-width) and (max-height: $max-height){
    @content;
  }
}

@mixin mq($min-width){
  @media screen and (min-width: $min-width){
    @content;
  }
}

@mixin theme($color){
  .item__img{
    border: 1px solid $color;
    border-radius: 100%;
    .icon-setting{
      color: $color;
    }
  }
  .item__head{
    color: $color;
  }
}

//8-TRUMPS
.theme{
  &-cyan{@include theme(#56D9FE)}
  &-purple{@include theme(#A3A0FB)}
  &-green{@include theme(#4AD991)}
}


.item{
  width: 20rem;
  height: 5rem;
  display: flex;
  align-items: center;
  background-color: #fff;
  // margin: .5rem 0;
  border-radius: 6px;
  padding-left: 1rem;
  @include mq('700px'){
    height: 6rem;
  }
  @include mq($md){
    width: 16rem;
  }
  @include mq($lg){
    height: 7rem;
    width: 20rem;
  }

  &__img{
    width: 3rem;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    .icon-setting{
      font-size: 2rem;
    }
  }

  &__head{
    font-size: 1.2rem;
  }

  &__main{
    margin-left: 2rem;
  }
}
</style>
